import type { OverviewResponse } from '../contract';
import { fmtKc, fmtNum, fmtShare } from '../format';
import { MetricRow, PctBadge } from './metric-row';
import styles from '../style.module.scss';

/** Khối "Fan & Fan Club" (đặc tả 04 §5, 06 E4). */
const FansSection = ({ ov }: { ov: OverviewResponse }) => {
  const f = ov.fans;
  if (!f) return null;
  const start = f.totalFansStart ?? null;
  const end = f.totalFansEnd ?? null;
  const activeRatio = end && end > 0 ? (f.activeFanClubFans / end) * 100 : null;
  return (
    <section className={styles.card} aria-label="Fan và Fan Club">
      <h2 className={styles.cardTitle}>Fan &amp; Fan Club</h2>
      <MetricRow label="Fan mới trong tháng" value={fmtNum(f.newFans)} />
      <MetricRow
        label="KC từ Fan Club"
        value={fmtShare(f.fanClubPct)}
        hint={`${fmtKc(f.fanClubDiamonds)} KC`}
      />
      <MetricRow
        label="Tổng fan đầu → cuối tháng"
        value={start !== null && end !== null ? `${fmtNum(start)} → ${fmtNum(end)}` : '—'}
        hint={
          start === null || end === null
            ? 'File tháng TikTok không có số fan đầu tháng.'
            : 'Chỉ cộng Creator có đủ cả hai số.'
        }
      />
      <MetricRow label="Tăng trưởng fan" value={<PctBadge pct={f.growthPct} />} />
      <MetricRow
        label="Fan Club hoạt động"
        value={fmtNum(f.activeFanClubFans)}
        hint={activeRatio !== null ? `≈ ${fmtShare(activeRatio)} tổng fan cuối tháng` : undefined}
      />
    </section>
  );
};

export default FansSection;
